module.exports = __webpack_public_path__ + "img/edge.ac222817.png";